import { Injectable } from '@angular/core';

@Injectable()
export class CreditCard {
    public id: string;
    public cardNumber: string;
    public expiryDate: string;
    public isPrimary: boolean;
    public cvv: string;
    public token: string;
    constructor() { }

}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/shared/models/credit-card.ts